import { render, staticRenderFns } from "./terrace.vue?vue&type=template&id=006c63b9&scoped=true&"
import script from "./terrace.vue?vue&type=script&lang=js&"
export * from "./terrace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c63b9",
  null
  
)

export default component.exports